
import React from 'react'
import formatMsg from '../../util/formatMsg';
import { timeutil, Helper, permissions } from "sharedresources";
import AutopayListBadge from '../AutopayListBadge/page';


const InvoiceMobileCard = (props: any) => {
    const invStatusColorMap = Helper.getInvStatusColorMap();
    const {
        invoiceObj,
        firebase,
        autopayEntry
    } = props;

    return (
        <div className='invoice-list-card'>
            <div className='invoice-card-1st-row'>
                <div className='inv-basic-detail-container'>
                    <div className='inv-pkg-name'>
                        {invoiceObj.packageName}
                    </div>
                    <div className='inv-sub-details-container'>
                        <div className='inv-user-img-container'>
                            <img
                                src='/images/user.png'
                                className='inv-user-img'
                            />
                        </div>
                        <div className='inv-user-name'>
                            {invoiceObj.profileName}
                        </div>
                    </div>
                    {/* The same badge the desktop table renders under the invoice number. Whether a
                        cycle is waiting for a card, or autopay has stopped being able to collect,
                        is exactly the thing a parent opens this screen on their phone to find out
                        — and it was the one column the mobile card dropped. */}
                    <AutopayListBadge
                        entry={autopayEntry}
                        style={{ whiteSpace: "normal", marginLeft: 5, alignSelf: "flex-start" }}
                    />
                </div>
                <div className='inv-data'>
                    <div className='mobile-inv-raise-date'>
                        <div className='inv-calendar-img-container'>
                            <img
                                src='/images/miniCalendar.png'
                                className='inv-calendar-img'
                            />
                        </div>
                        {timeutil.getInstance(invoiceObj.invoiceRaiseDate).format("DD MMM YYYY")}
                    </div>
                    <div className='mobile-inv-total'>
                        {Helper.getCurrency(firebase)}
                        {" "}
                        {invoiceObj.total}
                    </div>
                    <div
                        className='mobile-inv-status'
                        style={{ color: invStatusColorMap[invoiceObj.invoiceStatus] }}
                    >
                        {formatMsg(invoiceObj.invoiceStatus)}
                    </div>
                </div>
            </div>
            <div className='mobile-inv-horizontal-divider' />
            <div className='invoice-card-2nd-row'>
                <div className='inv-2nd-row-1st-col'>
                    <div className='mobile-inv-due-date-container'>
                        <div className='mobile-inv-due-date-header'>
                            {formatMsg('dueDate')}
                        </div>
                        <div
                            style={{ color: invoiceObj.invoiceStatus !== 'paid' ? invStatusColorMap[invoiceObj.invoiceStatus] : 'black' }}
                        >
                            {timeutil.getInstance(invoiceObj.dueDate).format("DD MMM YYYY")}
                        </div>
                    </div>
                    <div className='mobile-inv-vertical-divider' />
                    <div className='mobile-inv-num-container' >
                        <div className='mobile-inv-due-date-header'>
                            {formatMsg('invoiceNum')}
                        </div>
                        <div>
                            {invoiceObj.invoiceNumber}
                        </div>
                    </div>
                </div>
                <div className='purple-download-container'>
                    {permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.PAYMENT_DOWNLOAD_PDF, invoiceObj.centerId ? [invoiceObj.centerId] : []) &&
                        <><div className='inv-download-img-container'>
                            <img
                                src='/images/purpleDownload.png'
                                className='inv-download-img'
                            />
                        </div>
                            <div
                                onClick={() => (invoiceObj.pdfUrl) ? window.open(invoiceObj.pdfUrl, "_blank") : null}
                                className='inv-purple-download'
                            >
                                {formatMsg('download')}
                            </div>
                        </>}
                </div>
            </div>
            {Helper.getInvoiceBillingPeriodText(invoiceObj) && (
                <div className='mobile-inv-due-date-header' style={{ marginTop: 8 }}>
                    {formatMsg('billingPeriod')}:{" "}
                    <span style={{ color: 'black' }}>{Helper.getInvoiceBillingPeriodText(invoiceObj)}</span>
                </div>
            )}
        </div>
    )
}

export default InvoiceMobileCard